// tslint:disable:no-any
import {camelizeKeys} from 'humps';

export default function({data, createdAt}: any): any {
  const normalizedData: any = camelizeKeys(JSON.parse(data));
  const {id, cid} = normalizedData.message;
  return {id, cid, createdAt, data};
}



// WEBPACK FOOTER //
// ./src/utils/parseSbMessage.ts